import { cn } from "../lib/utils";

export function KPICard({ label, value, hint, icon: Icon, tone = "neutral", testId }) {
  const toneStyles = {
    neutral: "text-slate-900 dark:text-slate-50",
    green: "text-emerald-700 dark:text-emerald-400",
    amber: "text-amber-700 dark:text-amber-400",
    red: "text-rose-700 dark:text-rose-400",
  };
  return (
    <div
      data-testid={testId}
      className="rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5"
    >
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 dark:text-slate-400">
          {label}
        </p>
        {Icon && (
          <span className="text-slate-400 dark:text-slate-500">
            <Icon size={16} strokeWidth={1.75} />
          </span>
        )}
      </div>
      <p
        className={cn(
          "mt-3 font-display text-4xl font-semibold tracking-tight",
          toneStyles[tone]
        )}
      >
        {value}
      </p>
      {hint && (
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{hint}</p>
      )}
    </div>
  );
}
